<div class="avatar"
     [ngClass]="color">
  <mat-icon fontSet="material-icons-outlined">{{icon}}</mat-icon>
</div>
